'use client';

import type { LeadFormName } from '@/features/lead-form/constants/formName';
import type { LeadType } from '@/features/lead-form/constants/leadType';

import Form from './Form';
import { FormModeContext } from './_context';
import { FORM_MENUS, POPUP_FORM_NAME, POPUP_LEAD_TYPE } from './_config';
import type { FormAgreementOptions, FormField, FormKey, SubmitAction } from './_types';
import styles from './FormPopup.module.scss';

export type FormPopupContentProps = {
  onClose?: () => void;
  /** 프리셋 키. fields 미지정 시 FORM_MENUS 필드 사용 */
  type?: FormKey;
  fields?: FormField[];
  formName?: LeadFormName;
  leadType?: LeadType[];
  submitLabel?: string;
  agreement?: FormAgreementOptions;
  extraData?: Record<string, unknown>;
  submitAction?: SubmitAction;
};

/**
 * Button `action.type: 'popup'` + title 과 함께 쓰는 1회성 커스텀 폼 본문.
 *
 * @example
 * action={{
 *   type: 'popup',
 *   id: 'event-custom-form',
 *   title: '프로모션 상담 신청',
 *   content: <FormPopupContent type={FORM_KEY.PROMOTION} />,
 * }}
 */
export default function FormPopupContent({
  onClose,
  type,
  fields,
  formName = POPUP_FORM_NAME,
  leadType = POPUP_LEAD_TYPE,
  submitLabel,
  agreement,
  extraData,
  submitAction,
}: FormPopupContentProps) {
  const menu = type ? FORM_MENUS.find((m) => m.key === type) : undefined;
  const productExtra = menu?.productTypeValue
    ? { productType: [menu.productTypeValue] }
    : {};

  return (
    <FormModeContext.Provider value="popup">
      <Form
        type={type}
        fields={fields}
        formName={formName}
        leadType={leadType}
        agreement={agreement}
        submitLabel={submitLabel}
        submitAction={submitAction}
        extraData={{ ...productExtra, ...extraData }}
        className={styles.form_area}
        actionAreaClassName={styles.form_action_area}
        onSuccess={() => onClose?.()}
      />
    </FormModeContext.Provider>
  );
}
